import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { Dispatch } from '@src/app/_redux';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import './footer.scss';
import { getBrandAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';
import { actionCreators } from '@src/app/main/actions';

export interface FooterProps {
  disclaimerCopy: string;
  natGeoFooterLinks: any;
  getNatGeoFooterLinks: () => void;
}
const formatDisclaimerCopy = (disclaimerCopy: string) => {
  if (disclaimerCopy) {
    let currentYear = new Date().getFullYear();
    const regex = /<\$CURRENT_YEAR>/ig;
    return disclaimerCopy.replace(regex, currentYear.toString(10));
  } 
  return;
};

export class NatGeoFooter extends Component<FooterProps> {
  constructor(props: any) {
    super(props);
  }

  componentWillMount() {
    this.props.getNatGeoFooterLinks();
  }

  render() {
    return (
      <footer className="main-footer footer-body no-print">
        <Container className="no-print">
          <Row>
            <Col className="disclaimer-col">{formatDisclaimerCopy(this.props.disclaimerCopy)}</Col>
          </Row>
          <Row className="disclaimer-links">
            <Col className="disclaimer-col">
              {this.props.natGeoFooterLinks && 
                this.props.natGeoFooterLinks.length > 0 && 
                this.props.natGeoFooterLinks.map((disclaimer, index) => {
                  return (
                    <div key={index + 1} className={`disclaimer-link ${disclaimer.style || ''}`}>
                      <a
                        key={index}
                        href={disclaimer.url}
                        target="_blank"
                      >
                        {disclaimer.title}
                      </a>
                    </div>
                  );
                })}
            </Col>
          </Row>
        </Container>
      </footer>
    );
  }
}

const mapState = state => {
  let footerData = getBrandAdminConfigTableItem(
    state.adminConfig,
    state.clientConfig,
    'PageFooter',
  );
  return {
    disclaimerCopy: footerData.DisclaimerCopy,
    natGeoFooterLinks: state.natGeoFooterLinks.natGeoFooterLinks,
  };
};
const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getNatGeoFooterLinks: actionCreators.getNatGeoFooterLinks,
    },
    dispatch,
  );

export default connect(mapState, mapDispatchToProps)(NatGeoFooter);
